module.exports = __webpack_public_path__ + "img/oxygenConcentrator.e20e74f9.png";